import React from 'react';
import { UpdateForm } from './StatusMain';

export default function Home() {
  return <UpdateForm />;
}
